import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  tabsData: null,
};

const consultantsSlice = createSlice({
  name: 'consultantsSlice',
  initialState,
  reducers: {
    setConsultantsData: (state, action) => {
      state.tabsData = action.payload;
    },
  },
});

export const {
  setConsultantsData,
} = consultantsSlice.actions;

export default consultantsSlice.reducer;
